import React from 'react';
import { UrgencyLevel } from '../VehicleInspection.utils';
import * as S from './UrgencyBadge.styles';

interface UrgencyBadgeProps {
  urgencyLevel: UrgencyLevel;
  deadline: string;
  isExpired?: boolean;
}

export const UrgencyBadge = ({ urgencyLevel, deadline, isExpired }: UrgencyBadgeProps) => {
  if (urgencyLevel === 'none') {
    return null;
  }

  const getText = (): string => {
    if (isExpired) {
      return `Frist utløpt ${deadline}`;
    }
    return `Frist: ${deadline}`;
  };

  return <S.Badge text={getText()} color="primary" />;
};
